import { setData, getData, removeData } from '@/utils/auth'
import { login, logout, getUserMenu ,dictList} from '@/api/user'
import router from '@/router'

const user_token = 'entertainment_token'
const basicInfoIde = 'entertainment_basic_information'
const userInfoIde = 'entertainment_user_info' //用户基础信息标识符
const configIde = 'entertainment_user_config' //用户基础信息标识符
const menus = 'entertainment_menus'
const permission = 'entertainment_permission'
const activeIndex = 'entertainment_activeIndex' //菜单当前激活保持

// 状态
const state = {
  token: getData(user_token), // 设置token初始状态   token持久化 => 放到缓存中
  userInfo: getData(userInfoIde),
  basicInfo: getData(basicInfoIde),
  config: getData(configIde),
  menus: getData(menus),
  permission: getData(permission),
  userCard: true, // 控制home页面内,左侧菜单栏上方用户单元显示隐藏
  isClock: false, //控制人员日志表格刷新
  activeIndex: getData(activeIndex),
  isAddE: false, //控制新增从业人员展示数据，
  webscoketFun : null
}
// 修改状态
const mutations = {
  // 设置token
  setToken(state, token) {
    state.token = token // 设置token  只是修改state的数据  123 =》 1234
    // vuex变化 => 缓存数据
    setData(user_token, token) // vuex和 缓存数据的同步
  },
  // 设置用户信息
  setUserInfo(state, userInfo) {
    state.userInfo = { ...userInfo }
    setData(userInfoIde, { ...userInfo })
  },
  setBasicInfo(state, basicInfo) {
    state.basicInfo = { ...basicInfo }
    setData(basicInfoIde, { ...basicInfo })
  },
  setConfig(state, config) {
    state.config = { ...config }
    setData(configIde, { ...config })
  },
  setMenus(state, data) {
    state.menus = data
    setData(menus, [...data])
  },
  setPermission: (state, data) => {
    state.permission = [...data]

    setData(permission, [...data])
  },
  removePermission(state) {
    removeData(permission)
    state.permission = []
  },
  setActiveIndex: (state, data) => {
    state.activeIndex = data

    setData(activeIndex, data)
  },
  removeActiveIndex(state) {
    removeData(activeIndex)
    state.activeIndex = ''
  },
  removeMenus(state) {
    removeData(menus)
    state.menus = null
  },
  // 删除token缓存
  removeToken(state) {
    removeData(user_token)
    state.token = null
  },
  // 删除用户信息
  removeUserInfo(state) {
    removeData(userInfoIde)
    state.userInfo = {}
  },
  removeBasicInfo(state) {
    removeData(basicInfoIde)
    state.basicInfo = {}
  },
  removeConfig(state) {
    removeData(configIde)
    state.config = {}
  },
  set_userCard: (state, data) => {
    state.userCard = data
  },
  CHANGE_CLOCK_STATE: (state, isClock) => {
    state.isClock = isClock
  },
  CHANGE_ADD_E: (state,isAddE) =>{
    state.isAddE = isAddE
  },
  GET_WEBSCOKET: (state,webscoketFun) =>{
    state.webscoketFun = webscoketFun
  },
}
// 执行异步
const actions = {
  selectWebsocket({commit}){
    let url = "ws:127.0.0.1:7415"
    let websockets = new WebSocket(url);
    commit('webscoketFun',websockets)
  },
  async changeClockState({ commit }, data) {
    commit('CHANGE_CLOCK_STATE', data)
  },
  async changeAddEState({ commit }, data) {
    commit('CHANGE_ADD_E', data)
  },
  // 定义login action  也需要参数 调用action时 传递过来的参数
  async login(context, data) {
    const result = await login(data) // 实际上就是一个promise  result就是执行的结果
    // axios默认给数据加了一层data
    if (result.token) {
      context.dispatch('selectWebsocket')
      context.commit('setToken', result.token)
      context.commit('setUserInfo', result.user)
      context.commit('setConfig', result.config)
      //获取用户路由
      await context.dispatch('getUserMenu')
      // 获取码表
      await dictList()

    }
    return result
  },
  // 获取用户菜单路由
  async getUserMenu(context) {
    //获取用户路由与权限
    const res = await getUserMenu(context.state.userInfo.mobile)
    context.commit('setMenus', res.data) //存路由
    const permission = res.permission.filter(item => item)
    context.commit('setPermission', permission) //存权限
  },
  // 登出的action
  async logout(context) {
    const result = await logout(state.token)
    console.log(result)
    context.commit('removeToken')
    context.commit('removeUserInfo')
    context.commit('removeBasicInfo')
    context.commit('removeConfig')
    context.commit('removeMenus')
    context.commit('removePermission')
    context.commit('removeActiveIndex')
    router.push('/login')
    location.reload() //刷新页面
    // 重置路由
    location.reload()

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
